/******************************************************************************/


import '@awesome.me/webawesome-pro/dist/components/page/page.js';

import './App.css';
import App from './App.svelte';

import { mount } from 'svelte';


/******************************************************************************/


const app = mount(App, {
  target: document.body,
  props: {}
});


/******************************************************************************/


export default app;